import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./Search.module.sass";
import Icon from "../../Icon";
import Item from "./Item";
import Suggestion from "./Suggestion";
import { searchStudents } from "../../../services/search.service";

const Search = ({ className }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const navigate = useNavigate();
  const searchContainerRef = useRef(null);

  useEffect(() => {
    const search = async () => {
      if (query.trim() !== "") {
        const studentResults = await searchStudents(query);
        setResults(studentResults);
      } else {
        setResults([]);
      }
    };

    const timerId = setTimeout(() => {
      search();
    }, 300);

    return () => {
      clearTimeout(timerId);
    };
  }, [query]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchContainerRef]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setDropdownVisible(!!value);
  };

  const handleResultClick = (studentId) => {
    navigate(`/admin/students/${studentId}`);
    setQuery("");
    setDropdownVisible(false);
    setResults([]);
  };

  const handleClose = () => {
    setQuery("");
    setDropdownVisible(false);
    setResults([]);
  };

  return (
    <div ref={searchContainerRef} className={cn(styles.search, className, { [styles.active]: isDropdownVisible || query.length > 0 })}>
      <div className={styles.head}>
        <button className={styles.start}>
          <Icon name="search" size="24" />
        </button>
        <input
          className={styles.input}
          type="text"
          value={query}
          placeholder="Rechercher élève par ID, email, nom..."
          onChange={handleInputChange}
          onFocus={() => setDropdownVisible(!!query)}
        />
        <button className={styles.close} onClick={handleClose}>
          <Icon name="close-circle" size="24" />
        </button>
      </div>
      {isDropdownVisible && (
        <div className={styles.body}>
          {results.length > 0 ? (
            <>
              <div className={styles.box}>
                <div className={styles.category}>Élèves</div>
                <div className={styles.list}>
                  {results.map((student) => (
                    <Item
                      className={styles.item}
                      student={student}
                      key={student.id}
                      onClick={() => handleResultClick(student.id)}
                    />
                  ))}
                </div>
              </div>

              {results.some(student => student.contract) && (
                <div className={styles.box}>
                  <div className={styles.category}>Suggestions</div>
                  <div className={styles.list}>
                    {results
                      .filter(student => student.contract)
                      .map((student) => (
                        <Suggestion
                          className={styles.item}
                          contract={student.contract}
                          key={student.contract.id}
                        />
                      ))}
                  </div>
                </div>
              )}
            </>
          ) : (
            query && <div className={styles.box}><div className={styles.category}>Aucun résultat trouvé</div></div>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;